import type {
  GridOptions,
  IRowNode,
  PostProcessPopupParams,
  RowClassParams,
} from 'ag-grid-community';
import { postSort } from './plugins/with-provisional-row/utils';

export const DEFAULT_GRID_OPTIONS: GridOptions = {
  valueCache: true,
  animateRows: true,
  enableCellChangeFlash: true,
  suppressRowClickSelection: true,
  suppressRowDeselection: true,
  rowSelection: 'multiple',
  suppressCellFocus: true,
  suppressContextMenu: true,
  suppressFocusAfterRefresh: true,
  suppressMaintainUnsortedOrder: true,
  suppressDragLeaveHidesColumns: true,
  groupDisplayType: 'custom',
  excludeChildrenWhenTreeDataFiltering: true,
  debounceVerticalScrollbar: true,
  suppressMaxRenderedRowRestriction: true,
  maintainColumnOrder: true,
  overlayLoadingTemplate: '<div></div>',
  cellFlashDelay: 3000,
  postSortRows: postSort,
  getRowId: ({ data }) => (data?.taskId as number | string).toString(),
  isRowSelectable: (node: IRowNode) => node.id !== 'provisional',
  rowClassRules: {
    'task-grid-row-private': ({ data }: RowClassParams) => data?.private,
  },
  postProcessPopup: ({ ePopup, column, rowNode }: PostProcessPopupParams) => {
    if (column?.getId() !== 'status' || rowNode?.id !== 'provisional') {
      return;
    }

    ePopup.style.border = '2px solid var(--blue-60)';
    ePopup.style.borderRadius = '0';
  },
  defaultColDef: {
    resizable: true,
    sortable: true,
    editable: false,
    lockPinned: true,
    suppressMovable: true,
    suppressMenu: true,
    cellEditorPopup: true,
    cellEditorPopupPosition: 'over',
  },
  autoGroupColumnDef: {
    field: 'task',
    hide: true,
  },
};
